export enum FractalAction {
  SET_DAO,
  UPDATE_MODULE,
  INVALID,
  RESET,
}
